
(function () {
  function setupGallery(gallery) {
    if (gallery.dataset.gnReady) return;
    gallery.dataset.gnReady = "true";

    const track = gallery.querySelector("[data-gn-track]");
    const slides = [...track.children];
    const dots = [...gallery.querySelectorAll(".gn-card-gallery__dot")];

    function currentIndex() {
      return Math.round(track.scrollLeft / track.clientWidth);
    }

    function updateDots() {
      const index = currentIndex();
      dots.forEach((dot, i) => {
        dot.classList.toggle("is-active", i === index);
      });
    }

    function move(direction) {
      const index = Math.max(
        0,
        Math.min(slides.length - 1, currentIndex() + direction)
      );

      track.scrollTo({
        left: index * track.clientWidth,
        behavior: "smooth"
      });
    }

    gallery.querySelector("[data-gn-prev]")
      ?.addEventListener("click", () => move(-1));

    gallery.querySelector("[data-gn-next]")
      ?.addEventListener("click", () => move(1));

    let startX = 0;
    let startY = 0;
    let suppressClick = false;

    track.addEventListener("pointerdown", (event) => {
      startX = event.clientX;
      startY = event.clientY;
      suppressClick = false;
    }, { passive: true });

    track.addEventListener("pointerup", (event) => {
      suppressClick =
        Math.abs(event.clientX - startX) > 10 &&
        Math.abs(event.clientX - startX) >
          Math.abs(event.clientY - startY);
    }, { passive: true });

    track.addEventListener("click", (event) => {
      if (suppressClick) {
        event.preventDefault();
        suppressClick = false;
      }
    }, true);

    track.addEventListener("scroll", updateDots, { passive: true });
  }

  function initialize() {
    document.querySelectorAll("[data-gn-gallery]").forEach(setupGallery);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize);
  } else {
    initialize();
  }

  document.addEventListener("shopify:section:load", initialize);
})();
